<ng-container *transloco="let t">
  @if (showBlock()) {
    <pxw-button
      class="show-order"
      color="cyan"
      size="lg"
      display="block"
      [routerLink]="['/resumen']"
    >
      <span class="text">{{ t('showOrder.goToOrder') }}</span>
      <span class="amount">{{ amount() | currencyFormat }}</span>
    </pxw-button>
  }
</ng-container>
